(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters-mtc"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'DOMContentLoaded',
    () => {
      if(isCollectionsAllPage) {
        showCollectionTags();
      }
      else if(isCollectionPage) {
        checkCollectionInput();
      }
    }
  );
  const isCollectionsAllPage = window.location.pathname === "/collections/all" ? true : false;
  const isCollectionPage = window.location.pathname.startsWith("/collections/") ? true : false;

  // コレクション一覧のタグを表示する
  let showCollectionTags = () => {
    document.querySelector(".filter-category__tag-wrapper").classList.add("show-tags");
  }

  // URLからコレクションを取得する
  const getCollectionName = (() => {
    const matches = window.location.pathname.match(/collections\/([^?\/]+)/);
    const collectionName = matches ? decodeURIComponent(matches[1]) : null;
    return collectionName.replace(/-/g, "・");
  });

  // 特定コレクション配下の場合、チェックボックスが入った状態とする。
  const checkCollectionInput = (() => {
    console.log("checkCollectionInput!");
    const collectionName = getCollectionName();
    // チェックボックスを取得
    const checkbox__inputs = [...document.querySelectorAll(".checkbox__input")];
    checkbox__inputs.filter(checkbox => checkbox.getAttribute("data-label") == collectionName)
                    .forEach(checkbox => checkbox.checked = true); // チェックをいれる
  });
  } catch(e) { console.error(e); }
})();

})();
